<form [formGroup]="configForm" (ngSubmit)="onSubmit()" class="p-fluid">
  <p-accordion
    [activeIndex]="0"
    class="w-full"
    expandIcon="fas fa-chevron-down"
    collapseIcon="fas fa-chevron-up">
    @if (type !== 'teaser') {
      <p-accordionTab>
        <ng-template pTemplate="header">
          <div class="flex flex-column gap-1 font-normal">
            <strong>Grundeinstellungen</strong>
            @if (type !== 'text') {
              <span class="text-xs text-color-secondary">
                Farben, Sortierung, Werte einblenden, Vergleichswerte und
                Weiteres einstellen.
              </span>
            }
          </div>
        </ng-template>

        <div class="flex flex-column gap-3">
          @if (configForm.contains('headline')) {
            <div class="grid">
              <app-form-field-wrapper
                [name]="'headline'"
                label="Überschrift"
                [colSize]="12">
                <input pInputText formControlName="headline" />
              </app-form-field-wrapper>
            </div>
          }

          @if (
            configForm.contains('colorset') && colorsetStore.asArray();
            as colorsets
          ) {
            <app-header
              styleClass="mt-3 -mb-2"
              text="Farben und Legende"
              icon="fas fa-palette"></app-header>

            @if (hasFixedColorset(); as fixedColorset) {
              <div class="mt-3">
                <app-colors [colorset]="fixedColorset" />
                <p
                  class="text-sm text-color-secondary flex gap-2 mt-2 font-italic align-items-baseline">
                  <i class="fas fa-info-circle"></i> Das Farbset ist fixiert und
                  kann nicht verändert werden
                </p>
              </div>
            } @else {
              <div class="grid">
                <app-colorset-dropdown
                  [enableNewOption]="true"
                  (selectionChange)="patchColorset($event)"
                  formControlName="colorset"></app-colorset-dropdown>
              </div>
            }
          }
          @if (configForm.contains('invertColors')) {
            <div class="grid">
              <app-form-field-wrapper
                [floatingLabel]="false"
                [hideLabel]="true"
                [name]="'invertColors'"
                [colSize]="12">
                <p-checkbox
                  formControlName="invertColors"
                  [binary]="true"
                  label="Farben invertieren"></p-checkbox>
              </app-form-field-wrapper>
            </div>
          }
          @if (configForm.contains('legendPosition')) {
            <div class="grid">
              <app-form-field-wrapper
                label="Legendenposition"
                [floatingLabel]="true"
                [name]="'legendPosition'"
                [colSize]="6">
                <p-dropdown
                  formControlName="legendPosition"
                  [options]="chartLegendOptions">
                </p-dropdown>
              </app-form-field-wrapper>
            </div>
          }

          @if (configForm.contains('map')) {
            <div formGroupName="map">
              <div formGroupName="legend">
                <div class="grid">
                  <div class="flex align-items-center">
                    <app-form-field-wrapper
                      [floatingLabel]="false"
                      [hideLabel]="true"
                      [name]="'invert'"
                      [colSize]="12">
                      <p-checkbox
                        formControlName="invert"
                        [binary]="true"
                        label="Legende invertieren"
                        name="invert" />
                    </app-form-field-wrapper>
                  </div>
                </div>
                <div class="grid mt-3">
                  <app-form-field-wrapper
                    [hideLabel]="true"
                    [floatingLabel]="false"
                    [name]="'scaleMode'"
                    [colSize]="12">
                    <label class="font-bold block mb-3"
                      >Klasseneinteilung</label
                    >
                    <div class="flex gap-3">
                      <div class="field-checkbox">
                        <p-radioButton
                          inputId="scales_width"
                          value="width"
                          formControlName="scaleMode" />
                        <label for="scales_width" class="ml-2">
                          gleiche Klassenbreiten
                        </label>
                      </div>
                      <div class="field-checkbox">
                        <p-radioButton
                          inputId="scales_count"
                          value="count"
                          formControlName="scaleMode" />
                        <label for="scales_count" class="ml-2">
                          gleiche Klassenbesetzung
                        </label>
                      </div>
                    </div>
                  </app-form-field-wrapper>
                </div>

                <div class="grid">
                  <app-form-field-wrapper
                    [floatingLabel]="false"
                    [name]="'numberOfScales'"
                    [colSize]="4">
                    <label class="mb-2 font-bold block"
                      >Anzahl der Klassen</label
                    >
                    <p-dropdown
                      formControlName="numberOfScales"
                      [options]="numberOfScalesOptions">
                    </p-dropdown>
                  </app-form-field-wrapper>
                  <app-form-field-wrapper
                    [floatingLabel]="false"
                    [name]="'size'"
                    [colSize]="6">
                    <label class="mb-2 font-bold block">Legenden-Anzeige</label>
                    <p-dropdown
                      formControlName="size"
                      [options]="mapLegendOptions">
                    </p-dropdown>
                  </app-form-field-wrapper>
                  <app-form-field-wrapper
                    [floatingLabel]="false"
                    name="position"
                    [colSize]="12">
                    <label class="mb-2 font-bold block"
                      >Legenden-Position</label
                    >
                    <p-dropdown
                      formControlName="position"
                      [options]="mapLegendPositionOptions">
                    </p-dropdown>
                  </app-form-field-wrapper>
                </div>

                <div class="grid">
                  @if (activeWidget?.widget?.activeGroup) {
                    <app-form-field-wrapper
                      [floatingLabel]="false"
                      [name]="'numberOfScales'"
                      [colSize]="12">
                      <label class="mb-3 font-bold block"
                        >Klassen bei gruppierten Räumen</label
                      >
                      <div class="flex gap-4">
                        <p-radioButton
                          name="legendScope"
                          value="all"
                          label="gesamter Raum"
                          formControlName="legendScope"
                          inputId="legendScope" />
                        <p-radioButton
                          name="legendScope"
                          value="group"
                          label="pro Gruppe"
                          formControlName="legendScope"
                          inputId="legendScope" />
                      </div>
                    </app-form-field-wrapper>
                  }
                </div>
              </div>

              <div class="grid mt-3">
                <app-form-field-wrapper
                  [label]="'Kartenhintergrund'"
                  [name]="'tileLayer'"
                  [colSize]="12">
                  <p-dropdown
                    formControlName="tileLayer"
                    name="direction"
                    [options]="leafletTileLayerOptions"></p-dropdown>
                </app-form-field-wrapper>
              </div>
              <app-header text="Beschriftung" icon="fas fa-font"></app-header>
              <div formGroupName="captions">
                <div class="flex flex-column gap-2">
                  <div class="flex align-items-center">
                    <p-checkbox
                      formControlName="key"
                      [binary]="true"
                      label="Schlüssel"
                      name="key" />
                  </div>
                  <div class="flex align-items-center">
                    <p-checkbox
                      formControlName="name"
                      [binary]="true"
                      label="Name"
                      name="name" />
                  </div>
                  <div class="flex align-items-center">
                    <p-checkbox
                      formControlName="value"
                      [binary]="true"
                      label="Wert"
                      name="value" />
                  </div>
                  <div class="flex align-items-center">
                    <p-checkbox
                      formControlName="chart"
                      [binary]="true"
                      label="Säulendiagramm"
                      name="chart" />
                  </div>
                </div>

                <app-header
                  styleClass="mt-5"
                  text="Positionierung"
                  icon="fas fa-arrows-to-circle"></app-header>
                <div class="grid">
                  <app-form-field-wrapper
                    [floatingLabel]="false"
                    [hideLabel]="true"
                    name="style"
                    [colSize]="12">
                    <p-dropdown
                      formControlName="style"
                      [options]="mapTooltipStyleDropdownItems">
                      <ng-template let-item pTemplate="selectedItem">
                        <app-dropdown-option [item]="item" />
                      </ng-template>
                      <ng-template let-item pTemplate="item">
                        <app-dropdown-option [item]="item" />
                      </ng-template>
                    </p-dropdown>
                  </app-form-field-wrapper>
                </div>
              </div>


              <app-header
                styleClass="mt-5"
                text="Weitere Einstellungen"
                icon="fas fa-sliders-h"></app-header>
              <div>
                <label class="mt-3 mb-3 block font-bold"
                  >Transparenz der Räume</label
                >
                <app-ngx-slider
                  labelCeil="gering"
                  labelFloor="hoch"
                  data-value=""
                  [options]="{ floor: 0.1, ceil: 0.9, step: 0.1 }"
                  formControlName="districtOpacity"></app-ngx-slider>
              </div>
              <div>
                <label class="mt-5 mb-3 block font-bold"
                  >Icon-Größe der Standorte</label
                >
                <app-ngx-slider
                  labelFloor="klein"
                  labelCeil="groß"
                  [options]="{ floor: 0.5, ceil: 2, step: 0.1 }"
                  formControlName="poiSize"></app-ngx-slider>
              </div>
            </div>
          }

          @if (configForm.contains('mode')) {
            <div>
              <app-header
                styleClass="-mb-4"
                text="Anzeigemodus"
                icon="fas fa-cubes-stacked"></app-header>
              <div class="grid align-items-baseline">
                <app-form-field-wrapper name="mode" [colSize]="6">
                  <p-dropdown
                    formControlName="mode"
                    [options]="[
                      {
                        icon: 'fas fa-chart-column',
                        label: 'Säulen (vertikal)',
                        value: 'vertical',
                      },
                      {
                        icon: 'fas fa-chart-bar',
                        label: 'Balken (horizontal)',
                        value: 'horizontal',
                      },
                    ]">
                    <ng-template let-selectedItem pTemplate="selectedItem">
                      <app-dropdown-option [item]="selectedItem" />
                    </ng-template>
                    <ng-template let-item pTemplate="item">
                      <app-dropdown-option [item]="item" />
                    </ng-template>
                  </p-dropdown>
                </app-form-field-wrapper>

                <app-form-field-wrapper
                  styleClass="mt-4"
                  [floatingLabel]="false"
                  [hideLabel]="true"
                  name="stacked"
                  [colSize]="6">
                  <p-checkbox
                    formControlName="stacked"
                    [binary]="true"
                    label="Diagramm stapeln"></p-checkbox>
                </app-form-field-wrapper>
              </div>
            </div>
          }

          @if (
            configForm.contains('sort') &&
            activeWidget?.widget?.context !== 'external' &&
            activeWidget?.widget?.groupProperty !== 'dataLayer'
          ) {
            <div>
              <app-header
                text="Sortierung"
                icon="fas fa-arrow-down-wide-short"></app-header>
              <div formGroupName="sort" class="grid">
                <app-form-field-wrapper
                  [floatingLabel]="false"
                  [hideLabel]="true"
                  [name]="'enable'"
                  [colSize]="12">
                  <p-checkbox
                    formControlName="enable"
                    [binary]="true"
                    label="Sortierung anpassen"></p-checkbox>
                </app-form-field-wrapper>
                <app-form-field-wrapper
                  [label]="'Sortieren'"
                  [hideLabel]="true"
                  [floatingLabel]="false"
                  [name]="'property'"
                  [styleClass]="!configForm.value.sort.enable ? 'disabled' : ''"
                  [colSize]="4">
                  <div class="field-checkbox">
                    <p-radioButton
                      inputId="sort_label"
                      value="label"
                      formControlName="property" />
                    <label for="sort_label" class="ml-2"> Gruppe </label>
                  </div>
                  <div class="field-checkbox">
                    <p-radioButton
                      inputId="sort_value"
                      value="value"
                      formControlName="property" />
                    <label for="sort_value" class="ml-2"> Wert </label>
                  </div>
                </app-form-field-wrapper>
                <app-form-field-wrapper
                  [label]="'Auf-/ Absteigend'"
                  [name]="'direction'"
                  [styleClass]="!configForm.value.sort.enable ? 'disabled' : ''"
                  [hideLabel]="true"
                  [floatingLabel]="false"
                  [colSize]="4">
                  <div class="field-checkbox">
                    <p-radioButton
                      inputId="direction_asc"
                      value="asc"
                      formControlName="direction" />
                    <label for="direction_asc" class="ml-2">
                      aufsteigend
                    </label>
                  </div>
                  <div class="field-checkbox">
                    <p-radioButton
                      inputId="direction_desc"
                      value="desc"
                      formControlName="direction" />
                    <label for="direction_desc" class="ml-2">
                      absteigend
                    </label>
                  </div>
                </app-form-field-wrapper>
              </div>
            </div>
          }

          @if (configForm.contains('text')) {
            <app-header
              styleClass="mt-2 mb-0 text-base"
              text="Hintergrundfarbe"
              icon="fas fa-palette"></app-header>

            <div formGroupName="text">
              <div class="grid">
                <app-form-field-wrapper
                  [floatingLabel]="false"
                  [hideLabel]="true"
                  [name]="'backgroundColor'"
                  [colSize]="12">
                  <div class="mt-2 flex gap-3">
                    <p-colorPicker
                      formControlName="backgroundColor"
                      (onChange)="
                        onColorChange($event, configForm.get('text'))
                      " />
                    <input
                      (change)="
                        onTextColorChange($event, configForm.get('text'))
                      "
                      formControlName="backgroundColor"
                      pInputText
                      type="text"
                      class="p-input" />
                  </div>
                </app-form-field-wrapper>
              </div>

              <app-header
                styleClass="mt-5 mb-3 text-base"
                text="Ausrichtung"
                icon="fas fa-arrows-split-up-and-left"></app-header>

              <div class="grid">
                <app-form-field-wrapper
                  [floatingLabel]="false"
                  [hideLabel]="true"
                  [name]="'alignment'"
                  [colSize]="12">
                  <p-dropdown
                    formControlName="alignment"
                    [options]="textAlignmentDropdownItems">
                    <ng-template let-item pTemplate="selectedItem">
                      <app-dropdown-option [item]="item" />
                    </ng-template>
                    <ng-template let-item pTemplate="item">
                      <app-dropdown-option [item]="item" />
                    </ng-template>
                  </p-dropdown>
                </app-form-field-wrapper>
              </div>
            </div>
          }

          @if (formContains(['displayValues', 'showFullIndicatorName'])) {
            <app-header
              styleClass="mt-3 mb-2"
              text="Beschriftung"
              icon="fas fa-font"></app-header>
          }

          @if (configForm.contains('displayValues')) {
            <div class="grid">
              <app-form-field-wrapper
                [floatingLabel]="false"
                [hideLabel]="true"
                [name]="'displayValues'"
                [colSize]="12">
                <p-checkbox
                  formControlName="displayValues"
                  [binary]="true"
                  label="Werte anzeigen"></p-checkbox>
              </app-form-field-wrapper>
            </div>
          }

          @if (
            configForm.contains('showFullIndicatorName') &&
            activeWidget?.widget?.focusProperty !== 'indicator' &&
            activeWidget?.widget?.context !== 'external'
          ) {
            <div class="grid">
              <app-form-field-wrapper
                [floatingLabel]="false"
                [hideLabel]="true"
                [name]="'showFullIndicatorName'"
                [colSize]="12">
                <p-checkbox
                  formControlName="showFullIndicatorName"
                  [binary]="true"
                  label="Indikatorenname vollständig anzeigen"></p-checkbox>
              </app-form-field-wrapper>
            </div>
          }

          @if (
            configForm.contains('comparisonValues') &&
            activeWidget?.widget?.context !== 'external'
          ) {
            <div>
              <app-header
                styleClass="mt-3 mb-2"
                text="Vergleichswerte hinzufügen"
                icon="fas fa-scale-unbalanced-flip"></app-header>
              <div class="grid">
                <app-form-field-wrapper
                  [floatingLabel]="false"
                  [name]="'comparisonValues'"
                  [colSize]="12">
                  <app-comparison-value-select
                    formControlName="comparisonValues" />
                </app-form-field-wrapper>
              </div>
            </div>
          }

          @if (configForm.contains('displayRegression')) {
            <div class="grid">
              <app-form-field-wrapper
                [floatingLabel]="false"
                [hideLabel]="true"
                [name]="'displayRegression'"
                [colSize]="12">
                <p-checkbox
                  formControlName="displayRegression"
                  [binary]="true"
                  label="Regressionsgerade einblenden"></p-checkbox>
              </app-form-field-wrapper>
            </div>
          }

          @if (
            formContains([
              'dotSize',
              'featureOpacity',
              'borderWidth',
              'lineTension',
              'innerRadius ',
            ])
          ) {
            <app-header
              text="Weitere Einstellungen"
              icon="fas fa-sliders-h"></app-header>
          }

          @if (configForm.contains('dotSize')) {
            <div>
              <label class="font-bold block mb-3">Punktgröße</label>
              <app-ngx-slider
                labelFloor="klein"
                labelCeil="groß"
                data-value=""
                [options]="{ floor: 0.5, ceil: 4, step: 0.2 }"
                formControlName="dotSize"></app-ngx-slider>
            </div>
          }

          @if (configForm.contains('featureOpacity')) {
            <div>
              <label class="font-bold block mb-3">Transparenz</label>
              <app-ngx-slider
                labelCeil="gering"
                labelFloor="hoch"
                data-value=""
                [options]="{ floor: 0, ceil: 1, step: 0.1 }"
                formControlName="featureOpacity"></app-ngx-slider>
            </div>
          }

          @if (configForm.contains('borderWidth')) {
            <div>
              <label class="font-bold block mb-3">Linienbreite</label>
              <app-ngx-slider
                labelFloor="dünn"
                labelCeil="dick"
                data-value=""
                [options]="{ floor: 1, ceil: 4, step: 0.1 }"
                formControlName="borderWidth"></app-ngx-slider>
            </div>
          }

          @if (configForm.contains('lineTension')) {
            <div>
              <label class="font-bold block mb-3">Linienverlauf</label>
              <app-ngx-slider
                labelFloor="gerade"
                labelCeil="kurve"
                data-value=""
                [options]="{ floor: 0, ceil: 1, step: 0.1 }"
                formControlName="lineTension"></app-ngx-slider>
            </div>
          }

          @if (configForm.contains('innerRadius')) {
            <div>
              <label class="font-bold block mb-3"
                >Kreis / Ring-Darstellung</label
              >
              <div class="grid">
                <div class="col-12">
                  <app-ngx-slider
                    labelCeil="Ring"
                    labelFloor="kreis"
                    [options]="{ ceil: 1, floor: 0, step: 0.1 }"
                    formControlName="innerRadius"></app-ngx-slider>
                </div>
              </div>
            </div>
          }

          @if (configForm.contains('table')) {
            <app-header
              text="Tabelle anpassen"
              icon="fas fa-table"></app-header>
            <div formGroupName="table" class="grid">
              <app-form-field-wrapper
                [floatingLabel]="false"
                [hideLabel]="true"
                [name]="'transpose'"
                [colSize]="
                  activeWidget?.widget?.groupProperty !== 'dataLayer' ? 6 : 12
                ">
                <p-checkbox
                  formControlName="transpose"
                  [binary]="true"
                  label="Tabelle transponieren"></p-checkbox>
              </app-form-field-wrapper>
              @if (activeWidget?.widget?.groupProperty !== 'dataLayer') {
                <app-form-field-wrapper
                  [floatingLabel]="false"
                  [hideLabel]="true"
                  name="displayKeys"
                  [colSize]="6">
                  <p-checkbox
                    formControlName="displayKeys"
                    [binary]="true"
                    label="Schlüssel abbilden"></p-checkbox>
                </app-form-field-wrapper>
              }
              <app-form-field-wrapper
                name="captionTotal"
                [colSize]="6"
                label="Gesamt">
                <input
                  pInputText
                  name="captionTotal"
                  formControlName="captionTotal" />
              </app-form-field-wrapper>
              <app-form-field-wrapper
                name="captionAverage"
                [colSize]="6"
                label="Durchschnitt">
                <input
                  pInputText
                  name="captionAverage"
                  formControlName="captionAverage" />
              </app-form-field-wrapper>
              <app-form-field-wrapper
                name="captionDistrict"
                [colSize]="6"
                label="Teilraum">
                <input
                  pInputText
                  name="captionDistrict"
                  formControlName="captionDistrict" />
              </app-form-field-wrapper>
              <app-form-field-wrapper
                name="captionKey"
                [colSize]="6"
                label="Schlüssel">
                <input
                  pInputText
                  name="captionKey"
                  formControlName="captionKey" />
              </app-form-field-wrapper>
            </div>
          }
        </div>
      </p-accordionTab>
    }
    @if (activeWidget?.type === 'map') {
      <p-accordionTab>
        <ng-template pTemplate="header">
          <div class="flex flex-column gap-1 font-normal">
            <strong>Abgebildetes Jahr</strong>
            <span class="text-sm text-color-secondary">
              Welches Jahr soll abgebildet werden?
            </span>
          </div>
        </ng-template>
        <div class="grid">
          <app-form-field-wrapper
            name="dataLayer"
            [label]="'Im Jahr'"
            [colSize]="12"
            [floatingLabel]="false"
            [hideLabel]="true">
            @if (activeWidget && activeWidget?.widget?.context === 'external') {
              <app-wegweiser-fast-switch
                [widget]="activeWidget"
                variant="dropdown"></app-wegweiser-fast-switch>
            } @else {
              <app-layer-dropdown
                [withData]="config.indicators.length > 0"
                [withDataInIndicators]="widgetStore.gridIndicators()"
                [enableEmpty]="false"
                [(selection)]="selectedDataLayer"
                (selectionChange)="setDataLayer($event)"
                [globalSelector]="false"
                [selectedTypeId]="
                  selectedDataLayerType ? selectedDataLayerType._id : ''
                "></app-layer-dropdown>
            }
          </app-form-field-wrapper>
        </div>
      </p-accordionTab>

      <p-accordionTab>
        <ng-template pTemplate="header">
          <div class="flex flex-column gap-1 font-normal">
            <strong>Erreichbarkeit (Isochronen)</strong>
            <span class="text-sm text-color-secondary">
              Einstellungen für die Analyse der Erreichbarkeit.
            </span>
          </div>
        </ng-template>
        <div formGroupName="map">
          <div class="grid">
            <app-form-field-wrapper
              [label]="'Reiseart'"
              [name]="'isochroneProfile'"
              [colSize]="12">
              <p-dropdown
                formControlName="isochroneProfile"
                [options]="isochroneProfileOptions">
                <ng-template pTemplate="selectedItem" let-item>
                  <div class="flex align-items-center gap-2">
                    <i [class]="item.icon"></i>
                    <span>{{ item.label }}</span>
                  </div>
                </ng-template>
                <ng-template pTemplate="item" let-item>
                  <div class="flex align-items-center gap-2">
                    <i [class]="item.icon"></i>
                    <span>{{ item.label }}</span>
                  </div>
                </ng-template>
              </p-dropdown>
            </app-form-field-wrapper>
          </div>
          <div class="grid mt-2">
            <app-form-field-wrapper
              [label]="'Intervalle (Minuten)'"
              [name]="'isochroneMinutes'"
              [colSize]="12">
              <p-chips
                formControlName="isochroneMinutes"
                [addOnBlur]="true"
                [separator]="','"></p-chips>
            </app-form-field-wrapper>
          </div>
          <div class="grid mt-2">
            <app-colorset-dropdown
              label="Farben für Zeitintervalle"
              [enableNewOption]="true"
              formControlName="isochroneColorset"></app-colorset-dropdown>
          </div>
        </div>
      </p-accordionTab>
    }
    @if (availableConfig.includes('group')) {
      <p-accordionTab>
        <ng-template pTemplate="header">
          <div class="flex flex-column gap-1 font-normal">
            <strong>
              @if (type === 'table') {
                Tabellen-Aufbau
              } @else {
                Diagramm-Aufbau
              }
            </strong>
            <span class="text-xs text-color-secondary">
              Was soll verglichen werden? Wie soll gruppiert werden?
            </span>
          </div>
        </ng-template>

        <!-- Visual Diagram -->
        @if (getVisualConfigData(); as visualData) {
          <app-chart-config-visual
            [data]="visualData"></app-chart-config-visual>
        }

        <p-divider></p-divider>

        <!-- Presets -->
        <app-chart-config-presets
          class="block"
          [isPoiType]="isPoiType"
          [currentFocusProperty]="config.focusProperty"
          [currentGroupProperty]="config.groupProperty"
          (presetSelected)="applyPreset($event)"></app-chart-config-presets>

        <p-divider></p-divider>

        <app-header
          styleClass="mb-3"
          text="Manuelle Anpassung"
          icon="fas fa-sliders-h"></app-header>

        <div class="grid gap-2">
          <div
            class="text-sm w-full surface-ground text-color-secondary p-2 surface-border border-1 border-round">
            <app-form-field-wrapper
              name="focusProperty"
              label="Vergleiche folgende Dimensionen (fixiert auf 1 Wert)"
              [floatingLabel]="false"
              [colSize]="12">
              <p-dropdown
                [(ngModel)]="config.focusProperty"
                [ngModelOptions]="{ standalone: true }"
                [options]="focusOptions"
                (onChange)="setFocusProperty($event)">
                <ng-template pTemplate="selectedItem" let-selected>
                  <app-dropdown-option [item]="selected" />
                </ng-template>
                <ng-template let-item pTemplate="item">
                  <app-dropdown-option [item]="item" />
                </ng-template>
              </p-dropdown>
            </app-form-field-wrapper>
          </div>

          <div
            class="text-sm w-full surface-ground text-color-secondary p-2 surface-border border-1 border-round">
            <app-form-field-wrapper
              name="groupProperty"
              [floatingLabel]="false"
              [label]="
                isSingleAxisType
                  ? 'Dimension auf der Achse'
                  : 'Unterteilung nach'
              "
              [colSize]="12">
              <p-selectButton
                [allowEmpty]="false"
                [options]="getNonFocusProperties()"
                [(ngModel)]="config.groupProperty"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="setGroupProperty($event)"
                optionLabel="alt"
                optionValue="value" />
            </app-form-field-wrapper>
          </div>

          <div
            class="text-sm w-full surface-ground text-color-secondary p-2 surface-border border-1 border-round">
            @if (activeWidget && activeWidget.widget?.context !== 'local') {
              <app-wegweiser-fast-switch
                [widget]="activeWidget"
                variant="dropdown"></app-wegweiser-fast-switch>
            } @else {
              @if (
                activeWidget?.widget?.focusProperty === 'indicator' &&
                  activeWidget?.widget?.indicators;
                as indicatorIds
              ) {
                <app-form-field-wrapper
                  name="indicator"
                  [floatingLabel]="false"
                  label="Angezeigter Indikator"
                  [colSize]="12">
                  <app-indicator-dropdown
                    [isStandalone]="true"
                    [items]="indicatorStore.getByIds(indicatorIds)"
                    [selection]="
                      activeWidget &&
                      activeWidget.widget &&
                      activeWidget.widget.indicator
                        ? indicatorStore.getById(activeWidget.widget.indicator)
                        : null
                    "
                    [enableEmpty]="true"
                    (selectionChange)="
                      setIndicator($event)
                    "></app-indicator-dropdown>
                </app-form-field-wrapper>
              }

              @if (
                activeWidget &&
                activeWidget.widget &&
                activeWidget.widget.focusProperty === 'feature' &&
                selectedDataLayerType
              ) {
                <app-form-field-wrapper
                  name="feature"
                  [floatingLabel]="false"
                  [label]="
                    isPoiType ? 'Angezeigter Standort' : 'Angezeigter Teilraum'
                  "
                  [colSize]="12">
                  <app-feature-dropdown
                    [allowComparisonValues]="true"
                    [isStandalone]="true"
                    [selection]="activeWidget.widget.feature || ''"
                    [autoSelect]="true"
                    [dataLayerId]="
                      selectedDataLayer?._id ||
                      (layerStore.getLatestByParent(selectedDataLayerType._id)
                        ?._id ??
                        '')
                    "
                    (selectionChange)="selectFeature($event)" />
                </app-form-field-wrapper>
              }

              @if (activeWidget?.widget?.focusProperty === 'dataLayer') {
                <app-form-field-wrapper
                  name="dataLayer"
                  [colSize]="12"
                  label="Angezeigtes Jahr"
                  [floatingLabel]="false">
                  <app-layer-dropdown
                    [isStandalone]="true"
                    [withData]="true"
                    [withDataInIndicators]="widgetStore.gridIndicators()"
                    [enableEmpty]="false"
                    [(selection)]="selectedDataLayer"
                    (selectionChange)="setDataLayer($event)"
                    [globalSelector]="false"
                    [selectedTypeId]="
                      selectedDataLayerType ? selectedDataLayerType._id : ''
                    "></app-layer-dropdown>
                </app-form-field-wrapper>
              }
            }
          </div>
        </div>
      </p-accordionTab>
    }

    @if (
      activeWidget &&
      activeWidget.widget?.context === 'external' &&
      activeWidget.widget?.focusProperty !== 'dataLayer'
    ) {
      <p-accordionTab>
        <ng-template pTemplate="header">
          <div class="flex flex-column gap-1 font-normal">
            <strong>Ein- und ausblenden</strong>
            <span class="text-xs text-color-secondary">
              Sollen Jahre ausgeblendet werden?
            </span>
          </div>
        </ng-template>
        <div class="grid">
          <app-form-field-wrapper
            [floatingLabel]="false"
            [hideLabel]="true"
            [colSize]="12">
            <app-wegweiser-widget-config
              (widgetChange)="updateChartData()"
              [widget]="activeWidget"></app-wegweiser-widget-config>
          </app-form-field-wrapper>
        </div>
      </p-accordionTab>
    }

    @if (
      availableConfig.includes('disable') &&
      activeWidget?.widget?.context !== 'external'
    ) {
      <p-accordionTab>
        <ng-template pTemplate="header">
          <div class="flex flex-column gap-1 font-normal">
            <strong>Ein- und ausblenden</strong>
            <span class="text-xs text-color-secondary">
              Welche Jahre, Indikatoren oder Teilräume/ Standorte sollen
              abgebildet werden?
            </span>
          </div>
        </ng-template>

        @if (
          activeWidget?.widget?.focusProperty !== 'dataLayer' &&
          selectedDataLayerType
        ) {
          <app-header
            text="Jahre ein-/ausblenden"
            icon="fas fa-calendar-days"></app-header>
          <div class="grid">
            <app-form-field-wrapper
              [floatingLabel]="false"
              [hideLabel]="true"
              [colSize]="12">
              <app-year-checkbox-group
                label=""
                [selection]="config.disabledYears"
                [isStandalone]="true"
                (selectionChange)="onDisabledYearsUpdate($event)"
                [dataLayerTypeId]="selectedDataLayerType._id">
              </app-year-checkbox-group>
            </app-form-field-wrapper>
          </div>
        }

        @if (
          activeWidget?.widget?.focusProperty !== 'feature' &&
          selectedDataLayerType
        ) {
          <app-header
            [text]="
              selectedDataLayerType?.type === 'Polygon'
                ? 'Teilräume ein-/ausblenden'
                : 'Standorte ein-/ausblenden'
            "
            [icon]="
              selectedDataLayerType?.type === 'Polygon'
                ? 'fa-regular fa-map'
                : 'fas fa-location-dot'
            "></app-header>
          <div class="grid">
            <app-form-field-wrapper
              [floatingLabel]="false"
              [hideLabel]="true"
              [label]="(isPoiType ? 'Standorte' : 'Teilräume') + 'ausblenden'"
              [colSize]="12">
              <app-feature-checkbox-group
                [isStandalone]="true"
                (selectionChange)="onDisabledFeaturesUpdate($event)"
                [selection]="config.disabledFeatures"
                name="disabledFeatureKeys"
                [dataLayerId]="
                  selectedDataLayer?._id ??
                  layerStore.getLatestByParent(selectedDataLayerType._id)
                    ?._id ??
                  ''
                "></app-feature-checkbox-group>
            </app-form-field-wrapper>
          </div>
        }
      </p-accordionTab>
    }

    @if (activeWidget?.type === 'map') {
      <p-accordionTab>
        <ng-template pTemplate="header">
          <div class="flex flex-column gap-1 font-normal">
            <strong>Diagramme ein- und ausblenden</strong>
            <span class="text-xs text-color-secondary">
              Welche Säulendiagramme sollen auf der Karte angezeigt werden?
            </span>
          </div>
        </ng-template>

        @if (
          config.map &&
          activeWidget?.widget?.map?.captions?.chart &&
          selectedDataLayerType
        ) {
          <app-header
            text="Aktivierte Kartendiagramme"
            icon="fas fa-chart-column"></app-header>
          <div class="grid">
            <app-form-field-wrapper
              [floatingLabel]="false"
              [hideLabel]="true"
              label="Diagramm ausblenden"
              [colSize]="12">
              <app-feature-checkbox-group
                [concatComparisonValues]="false"
                [isStandalone]="true"
                (selectionChange)="onDisabledMapChartsUpdate($event)"
                [selection]="config.disabledCharts || []"
                name="disabledCharts"
                [dataLayerId]="
                  selectedDataLayer?._id ??
                  layerStore.getLatestByParent(selectedDataLayerType._id)
                    ?._id ??
                  ''
                "></app-feature-checkbox-group>
            </app-form-field-wrapper>
          </div>
        } @else {
          <p class="text-color-secondary">
            <strong class="flex align-items-center gap-2"
              ><i class="fas fa-info-circle"></i> Diagramme deaktiviert</strong
            >
          </p>
          <p>
            <p-button
              size="small"
              styleClass="w-auto"
              rounded="true"
              type="button"
              label="Jetzt Diagramme aktivieren"
              icon="fas fa-check"
              (click)="toggleCharts()" />
          </p>
        }
      </p-accordionTab>
    }

    @if (availableConfig.includes('axis')) {
      <p-accordionTab>
        <ng-template pTemplate="header">
          <div class="flex flex-column gap-1 font-normal">
            <strong>Achsen</strong>
            <span class="text-xs text-color-secondary">
              Gibt es eine Achsenbeschriftung? Sollen die Achsen individuell
              eingestellt werden?
            </span>
          </div>
        </ng-template>

        @if (configForm.contains('axis')) {
          <div formGroupName="axis">
            <h4 class="mb-0">x-Achse</h4>
            <div class="grid" formGroupName="x">
              <app-form-field-wrapper [label]="'Beschriftung'" [colSize]="12">
                <input pInputText formControlName="label" />
              </app-form-field-wrapper>
              <app-form-field-wrapper [label]="'Minimalwert'" [colSize]="6">
                <p-inputNumber
                  mode="decimal"
                  [minFractionDigits]="0"
                  [maxFractionDigits]="2"
                  formControlName="min" />
              </app-form-field-wrapper>
              <app-form-field-wrapper [label]="'Maximalwert'" [colSize]="6">
                <p-inputNumber
                  mode="decimal"
                  [minFractionDigits]="0"
                  [maxFractionDigits]="2"
                  formControlName="max" />
              </app-form-field-wrapper>
            </div>

            <h4 class="mb-0">y-Achse</h4>
            <div class="grid" formGroupName="y">
              <app-form-field-wrapper [label]="'Beschriftung'" [colSize]="12">
                <input pInputText formControlName="label" />
              </app-form-field-wrapper>
              <app-form-field-wrapper [label]="'Minimalwert'" [colSize]="6">
                <p-inputNumber
                  mode="decimal"
                  [minFractionDigits]="0"
                  [maxFractionDigits]="2"
                  formControlName="min" />
              </app-form-field-wrapper>
              <app-form-field-wrapper [label]="'Maximalwert'" [colSize]="6">
                <p-inputNumber
                  mode="decimal"
                  [minFractionDigits]="0"
                  [maxFractionDigits]="2"
                  formControlName="max" />
              </app-form-field-wrapper>
            </div>
          </div>
        }

        @if (
          activeWidget?.type === 'bubble' || activeWidget?.type === 'scatter'
        ) {
          <p-divider />
          <button
            class="w-auto"
            pButton
            label="Achsen tauschen"
            icon="fas fa-shuffle"
            (click)="swapAxisProperties()"
            [rounded]="true"></button>
        }
      </p-accordionTab>
    }

    @if (configForm.contains('teaser')) {
      <div formGroupName="teaser">
        <div formArrayName="items">
          <div
            class="mb-3"
            *ngFor="
              let teaserControl of teaserFormArray.controls;
              let i = index
            "
            [formGroupName]="i">
            <app-header
              styleClass="mt-4"
              icon="fas fa-image"
              [text]="'Slide ' + (i + 1)"></app-header>

            <p-accordion [activeIndex]="0">
              <p-accordionTab header="Beschriftung">
                <div class="grid">
                  <app-form-field-wrapper
                    [name]="'topmark'"
                    label="Kopfzeile"
                    [colSize]="12">
                    <input pInputText formControlName="topmark" />
                  </app-form-field-wrapper>
                  <app-form-field-wrapper
                    [name]="'header'"
                    label="Titel"
                    [colSize]="12">
                    <input pInputText formControlName="header" />
                  </app-form-field-wrapper>
                  <app-form-field-wrapper [name]="'content'" [colSize]="12">
                    <p-editor
                      [modules]="{ nbspFix: true }"
                      placeholder="Inhalt"
                      formControlName="content"
                      [style]="{ height: '12rem' }">
                      <ng-template pTemplate="header">
                        <span class="ql-formats">
                          <button
                            type="button"
                            class="ql-bold"
                            aria-label="Bold"></button>
                          <button
                            type="button"
                            class="ql-italic"
                            aria-label="Italic"></button>
                          <button
                            type="button"
                            class="ql-underline"
                            aria-label="Underline"></button>
                        </span>
                      </ng-template>
                    </p-editor>
                  </app-form-field-wrapper>
                </div>
              </p-accordionTab>
              <p-accordionTab header="Bild">
                <div *ngIf="teaserImages && teaserImages.length" class="grid">
                  <app-form-field-wrapper
                    [floatingLabel]="false"
                    [hideLabel]="true"
                    [name]="'backgroundImage'"
                    [colSize]="12">
                    <p-dropdown
                      [showClear]="true"
                      formControlName="backgroundSrc"
                      placeholder="Hintergrundbild auswählen"
                      class="image-dropdown"
                      [options]="teaserImages"
                      optionValue="_id"
                      optionLabel="_id"
                      (onChange)="
                        onTeaserImageChange($event.value, teaserControl)
                      ">
                      <ng-template let-item pTemplate="selectedItem">
                        <img
                          class="w-auto"
                          [ngSrc]="item.src"
                          width="112"
                          height="45"
                          alt="bg-teaser" />
                      </ng-template>
                      <ng-template let-item pTemplate="item">
                        <div class="row-items">
                          <img
                            class="w-auto"
                            [ngSrc]="item.src"
                            width="112"
                            height="82"
                            alt="bg-teaser" />
                        </div>
                      </ng-template>
                    </p-dropdown>
                  </app-form-field-wrapper>
                </div>
                <app-form-field-wrapper
                  [floatingLabel]="false"
                  [hideLabel]="true"
                  [name]="'backgroundColor'"
                  [colSize]="12">
                  <app-header
                    styleClass="mt-5 mb-3 text-base"
                    text="Hintergrundfarbe"
                    icon="fas fa-palette"></app-header>

                  <div class="flex gap-3">
                    <p-colorPicker
                      formControlName="backgroundColor"
                      (onChange)="onColorChange($event, teaserControl)" />
                    <input
                      (change)="onTextColorChange($event, teaserControl)"
                      formControlName="backgroundColor"
                      pInputText
                      type="text"
                      class="p-input" />
                  </div>
                </app-form-field-wrapper>
              </p-accordionTab>

              <p-accordionTab header="Weiterleitung">
                <div class="grid">
                  <app-teaser-item-dropdown formControlName="bookmark" />
                </div>

                <div class="grid">
                  <app-form-field-wrapper
                    [name]="'href'"
                    label="Externe Webseite"
                    [colSize]="6"
                    help="https://www.kommunal-atlas.de"
                    [formField]="getHrefControl(i)">
                    <input pInputText formControlName="href" />
                  </app-form-field-wrapper>

                  <app-form-field-wrapper
                    [name]="'linkCaption'"
                    label="Anzuzeigender Text"
                    [colSize]="6">
                    <input pInputText formControlName="linkCaption" />
                  </app-form-field-wrapper>
                </div>
              </p-accordionTab>
            </p-accordion>
          </div>
        </div>

        <div class="flex gap-3 align-items-center">
          <app-form-field-wrapper
            [floatingLabel]="false"
            [hideLabel]="true"
            [name]="'autoPlay'"
            [colSize]="6">
            <p-checkbox
              formControlName="autoPlay"
              [binary]="true"
              label="Automatischer Durchlauf"></p-checkbox>
          </app-form-field-wrapper>
          <button
            pButton
            class="w-auto ml-auto"
            severity="success"
            (click)="addTeaser()"
            [rounded]="true"
            type="button"
            label="Slide hinzufügen"
            icon="fas fa-circle-plus"></button>
        </div>
      </div>
    }
    @if (activeWidget?.type === 'map') {
      <div formGroupName="map">
        <div formArrayName="poi">
          @for (poiControl of poiFormArray.controls; let i = $index; track i) {
            <p-accordionTab>
              <ng-template pTemplate="header">
                @if (getPoiFromConfig(i); as poi) {
                  <div class="flex align-items-center gap-2 w-full">
                    @if (poi.icon) {
                      <app-svg-icon [key]="poi.icon"></app-svg-icon>
                    }
                    {{ poi.name }}: Farben, Klassen, Skalen
                  </div>
                }
              </ng-template>

              @if (getPoiConf(i); as poiConf) {
                <div [formGroupName]="i">
                  <div formGroupName="legend">
                    <div class="grid">
                      <app-colorset-dropdown
                        [enableNewOption]="true"
                        formControlName="colorset"></app-colorset-dropdown>
                    </div>

                    <div class="grid">
                      <div class="flex align-items-center">
                        <app-form-field-wrapper
                          [floatingLabel]="false"
                          [hideLabel]="true"
                          [name]="'invert'"
                          [colSize]="12">
                          <p-checkbox
                            formControlName="invert"
                            [binary]="true"
                            label="Legende invertieren"
                            name="invert" />
                        </app-form-field-wrapper>
                      </div>
                    </div>
                    @if (poiConf.indicators?.length === 1) {
                      <div class="grid mt-3">
                        <app-form-field-wrapper
                          [hideLabel]="true"
                          [floatingLabel]="false"
                          [name]="'scaleMode'"
                          [colSize]="12">
                          <label class="font-bold block mb-3"
                            >Klasseneinteilung</label
                          >
                          <div class="flex gap-3">
                            <div class="field-checkbox">
                              <p-radioButton
                                inputId="scales_width"
                                value="width"
                                formControlName="scaleMode" />
                              <label for="scales_width" class="ml-2">
                                gleiche Klassenbreiten
                              </label>
                            </div>
                            <div class="field-checkbox">
                              <p-radioButton
                                inputId="scales_count"
                                value="count"
                                formControlName="scaleMode" />
                              <label for="scales_count" class="ml-2">
                                gleiche Klassenbesetzung
                              </label>
                            </div>
                          </div>
                        </app-form-field-wrapper>
                      </div>

                      <div class="grid">
                        <app-form-field-wrapper
                          [floatingLabel]="false"
                          [name]="'numberOfScales'"
                          [colSize]="4">
                          <label class="mb-2 font-bold block"
                            >Anzahl der Klassen</label
                          >
                          <p-dropdown
                            placeholder="Standard"
                            formControlName="numberOfScales"
                            [options]="numberOfScalesOptions">
                          </p-dropdown>
                        </app-form-field-wrapper>
                      </div>
                    }
                  </div>
                </div>
              }
            </p-accordionTab>
          }
        </div>
      </div>
    }
  </p-accordion>
</form>
